import { get } from 'lodash';
import React from 'react';

// import Schemas
import { EMOB_LIS_STANDORTE_PATHS } from 'src/lib/constants/componentsPath';
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import InvestitionKostenAntragEmobLis, { getFormStrucInvestitionKostenAntragEmobLis } from './InvestitionKostenAntragEmobLis';
const P = AntragSchema.attributes;

export const GetInvestitionkostenAntragEmobLis = (application: any, kostenkategorie: any, hasComment?: boolean) => {
	const allStandorte_arr = get(
		application,
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.path,
		[],
	);

	const standardOrteStruc = allStandorte_arr.map((ele: any, i: number) => {
		const standOrtName = () => {
			const standOrtName =
				get(ele, EMOB_LIS_STANDORTE_PATHS.StasseUndHausnummer, '') ? `(${get(ele, EMOB_LIS_STANDORTE_PATHS.StasseUndHausnummer, '')})` : i + 1;
			return standOrtName;
		};

		return {
			label: `Standort ${standOrtName()}`,
			content: <InvestitionKostenAntragEmobLis standortGroupId={get(ele, EMOB_LIS_STANDORTE_PATHS.GroupId, '')} hasComment={hasComment} />,
			formStruc: getFormStrucInvestitionKostenAntragEmobLis(application, kostenkategorie, get(ele, EMOB_LIS_STANDORTE_PATHS.GroupId, '')),
		};
	});

	return [...standardOrteStruc];
};
